import { Spinner as BootstrapSpinner } from 'react-bootstrap';

const PageLoading = () => (
	<div className="container pt-5 ml-3">
		<BootstrapSpinner animation="border" size="lg" />
	</div>
);

export default PageLoading;
